/**
 * @generated SignedSource<<7a66b95472cc22ac70b05f4600e9e758>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalStoreList_signalWorkspace$data = {
  readonly archivedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly signals: ReadonlyArray<{
    readonly id: string;
    readonly store: {
      readonly id: string;
      readonly name: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalStoreListItem_Signal">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalDescription_signalWorkspace">;
  readonly " $fragmentType": "WorkspaceSignalStoreList_signalWorkspace";
};
export type WorkspaceSignalStoreList_signalWorkspace$key = {
  readonly " $data"?: WorkspaceSignalStoreList_signalWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceSignalStoreList_signalWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceSignalStoreList_signalWorkspace",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "workspaceId",
          "variableName": "workspaceId"
        }
      ],
      "concreteType": "Signal",
      "kind": "LinkedField",
      "name": "signals",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "store",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceSignalStoreListItem_Signal"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "archivedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceSignalDescription_signalWorkspace"
    }
  ],
  "type": "SignalWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "e92e56b783ad2178cf1c289311c5ba4f";

export default node;
